// extracted by mini-css-extract-plugin
module.exports = {"Container":"styles_Container__MQ8ru","WithPadding":"styles_WithPadding__5ELKj"};